<template>
  <v-container class="toggle animated" fluid>
    <v-row>
      <!-- Products -->
      <v-col cols="12" md="3">
        <v-card elevation="3" color="secondary">
          <v-card-title style="font-family: Saira Condensed, sans-serif;">{{ $t('Dashboard.Products') }}</v-card-title>
          <v-card-text>
            <v-row class="d-flex justify-center align-center">
              <v-col cols="6"></v-col>
              <v-col cols="6" class="text-right">
                <div class="text-h3 font-weight-bold mr-4">{{ productsCount }}</div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Users -->
      <v-col cols="12" md="3">
        <v-card elevation="3" color="secondary">
          <v-card-title style="font-family: Saira Condensed, sans-serif;">{{ $t('Dashboard.Users') }}</v-card-title>
          <v-card-text>
            <v-row class="d-flex justify-center align-center">
              <v-col cols="6"></v-col>
              <v-col cols="6" class="text-right">
                <div class="text-h3 font-weight-bold mr-4">{{ usersCount }}</div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Raffles -->
      <v-col cols="12" md="3">
        <v-card elevation="3" color="secondary">
          <v-card-title style="font-family: Saira Condensed, sans-serif;">{{ $t('Dashboard.Raffles') }}</v-card-title>
          <v-card-text>
            <v-row class="d-flex justify-center align-center">
              <v-col cols="6"></v-col>
              <v-col cols="6" class="text-right">
                <div class="text-h3 font-weight-bold mr-4">{{ totalRaffles }}</div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Purchases -->
      <v-col cols="12" md="3">
        <v-card elevation="3" color="secondary">
          <v-card-title style="font-family: Saira Condensed, sans-serif;">{{ $t('Dashboard.Total_Purchases') }}</v-card-title>
          <v-card-text>
            <v-row class="d-flex justify-center align-center">
              <v-col cols="6"></v-col>
              <v-col cols="6" class="text-right">
                <div class="text-h3 font-weight-bold mr-4">{{ totalPurchases }}</div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import { defineComponent } from "vue";

export default defineComponent({
  name: "Dashboard",
  data() {
    return {
      dashboardData: null,
      loading: true
    };
  },
  computed: {
    productsCount() {
      return this.dashboardData?.products?.active ?? 0;
    },
    usersCount() {
      return this.dashboardData?.users ?? 0;
    },
    totalRaffles() {
      return this.dashboardData?.raffles ?? 0;
    },
    totalPurchases() {
      return this.dashboardData?.purchases?.all ?? 0;
    }
  },
  methods: {
    async fetchDashboardData() {
      const token = localStorage.getItem("maherco-admin-accesstoken");
      if (!token) {
        console.warn("Unable to initialize dashboard. No token found.");
        return;
      }

      try {
        const response = await axios.get(
          `${process.env.VUE_APP_SERVER_URL}/api/admin/dashboard`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "x-admin-key": process.env.VUE_APP_X_ADMIN_KEY
            }
          }
        );

        if (response.data) {
          this.dashboardData = response.data.data;
        }
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      } finally {
        this.loading = false;
      }
    }
  },
  mounted() {
    this.fetchDashboardData();
  }
});
</script>

<style scoped>
</style>